/** 预设签字栏：绑定打印数据字段 */
export const SIGNATURE_PRESET_KEYS = [
  { key: 'auditor_name', defaultLabel: '审核' },
  { key: 'salesperson_name', defaultLabel: '销售员' },
  { key: 'creator_name', defaultLabel: '开单人' },
  { key: 'recipient_name', defaultLabel: '收货人' }
]

export function defaultLabelForPresetKey (key) {
  const p = SIGNATURE_PRESET_KEYS.find((x) => x.key === key)
  return p ? p.defaultLabel : key
}

function trimFixedName (raw) {
  if (raw == null) return ''
  return String(raw.fixedName != null ? raw.fixedName : raw.fixed_name != null ? raw.fixed_name : '').trim()
}

function readBlankSignature (raw) {
  if (!raw) return false
  const v = raw.blankSignature != null ? raw.blankSignature : raw.blank_signature
  return v === true || v === 1 || v === '1' || v === 'true'
}

function normalizeRawItem (raw, i) {
  if (raw && raw.kind === 'custom') {
    return {
      id: raw.id || `custom_${i}_${Date.now()}`,
      kind: 'custom',
      label: (raw.label || '').trim(),
      fixedName: trimFixedName(raw),
      blankSignature: readBlankSignature(raw)
    }
  }
  if (raw && raw.kind === 'preset' && raw.key) {
    return {
      id: raw.id || `preset_${raw.key}`,
      kind: 'preset',
      key: raw.key,
      label: (raw.label || '').trim(),
      fixedName: trimFixedName(raw),
      blankSignature: readBlankSignature(raw)
    }
  }
  return null
}

/**
 * 从模板配置解析为统一的 items 列表（有序，仅包含要显示的栏位）
 */
export function migrateSignatureItems (sig) {
  if (!sig) return []
  if (Array.isArray(sig.items) && sig.items.length) {
    return sig.items.map((raw, i) => normalizeRawItem(raw, i)).filter(Boolean)
  }
  if (Array.isArray(sig.enabledFields) && sig.enabledFields.length) {
    return sig.enabledFields.map((key) => ({
      id: `preset_${key}`,
      kind: 'preset',
      key,
      label: '',
      fixedName: ''
    }))
  }
  if (Array.isArray(sig.fields) && sig.fields.length) {
    return sig.fields
      .map((f, i) => {
        const known = SIGNATURE_PRESET_KEYS.some((p) => p.key === f.field)
        if (known) {
          const def = defaultLabelForPresetKey(f.field)
          const lbl = (f.label || '').trim()
          return {
            id: `preset_${f.field}_${i}`,
            kind: 'preset',
            key: f.field,
            label: lbl && lbl !== def ? lbl : '',
            fixedName: ''
          }
        }
        const id =
          f.field && String(f.field).startsWith('custom_')
            ? f.field
            : `custom_${i}_${Date.now()}`
        return {
          id,
          kind: 'custom',
          label: (f.label || '').trim() || '签名',
          fixedName: ''
        }
      })
      .filter((x) => x && (x.kind !== 'custom' || x.label))
  }
  return []
}

export function displayLabelForItem (item) {
  if (!item) return ''
  if (item.kind === 'custom') return item.label || '签名'
  return (item.label && item.label.trim()) || defaultLabelForPresetKey(item.key)
}

/** 从打印数据取值的字段名；自定义栏无绑定 */
export function valueKeyForItem (item) {
  if (!item || item.kind !== 'preset') return null
  return item.key || null
}

/**
 * 签名栏下划线内最终文案：预设签名人优先；其次「留空」不写业务数据；否则从 fetchFromData(key) 取。
 * @param {object} item 签名配置项
 * @param {(key: string) => string} fetchFromData 从打印数据取预设字段值
 */
export function resolveSignatureLineValue (item, fetchFromData) {
  const fixed = (item?.fixedName || '').trim()
  if (fixed) return fixed
  if (item && (item.blankSignature === true || item.blank_signature === true)) return ''
  const k = valueKeyForItem(item)
  if (!k || typeof fetchFromData !== 'function') return ''
  try {
    const v = fetchFromData(k)
    if (v === null || v === undefined) return ''
    return String(v)
  } catch {
    return ''
  }
}

export function buildSignaturesPayload (items) {
  const clean = (items || []).filter((it) => {
    if (it.kind === 'custom') return (it.label || '').trim().length > 0
    return it.kind === 'preset' && it.key
  })
  return {
    items: clean.map((it) => {
      const base = {
        id: it.id,
        kind: it.kind,
        fixedName: (it.fixedName || '').trim(),
        ...(it.blankSignature ? { blankSignature: true } : {})
      }
      if (it.kind === 'preset') {
        return { ...base, key: it.key, label: (it.label || '').trim() }
      }
      return { ...base, label: (it.label || '').trim() }
    }),
    enabledFields: clean.filter((it) => it.kind === 'preset' && it.key).map((it) => it.key),
    fields: clean.map((it) => ({
      field: it.kind === 'preset' ? it.key : it.id,
      label: displayLabelForItem(it)
    }))
  }
}
